import { Component, EventEmitter, inject, Input, OnDestroy, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { AppointmentState } from '../../../appointment.state';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  AppointmentSpecServiceAddEditComponent
} from '../appointment-spec-service-add-edit/appointment-spec-service-add-edit.component';
import { TranslateModule, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'beautyapp-appointment-spec-services',
  templateUrl: './appointment-spec-services.component.html',
  styleUrls: ['./appointment-spec-services.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NzDividerModule,
    NzIconModule,
    NzButtonModule,
    NzGridModule,
    NzCardModule,
    NzSpaceModule,
    NzPopconfirmModule,
    NzTagModule,
    TranslateModule,
    TranslatePipe,
    NzTooltipDirective
  ]
})
export class AppointmentSpecServicesComponent implements OnDestroy {
  private modalService = inject(NzModalService);
  private store = inject(Store);
  private translateService = inject(TranslateService);

  @Input() serviceId?: string;
  @Input() serviceSpecs: any[] = [];
  @Input() bookingId?: string;
  @Input() bookingStatus?: any;
  @Input() viewOnly = false;
  @Input() employee: any;
  @Input() isSpecial: boolean = false;
  @Output() serviceSpecsUpdate: EventEmitter<any[]> = new EventEmitter<any[]>();
  data: any[] = [];
  list: Array<{ loading: boolean; name: any }> = [];
  sub$: Subject<any> = new Subject<any>();

  @Select(AppointmentState.getSpecServices) specServices$!: Observable<any[]>;

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }

  addEditService(spec: any = null) {
    const modal = this.modalService.create({
      nzClosable: false,
      nzMaskClosable: false,
      nzTitle: this.translateService.instant('calendar.addSpecialProcedure'),
      nzContent: AppointmentSpecServiceAddEditComponent,
      nzWidth: '600px',
      nzData: {
        serviceId: this.serviceId,
        bookingId: this.bookingId,
        spec,
      },
    });
    modal.afterClose.subscribe((res) => {
      if (res && res.spec) {
        // Upsert a single spec by serviceId — append when new, replace when
        // editing an existing row. Mirrors the products afterClose contract and
        // keeps one entry per procedure (beaut-337). Removal is via delete().
        const existing = this.serviceSpecs || [];
        const idx = existing.findIndex((m) => m.serviceId === res.spec.serviceId);
        this.serviceSpecs =
          idx === -1
            ? [...existing, res.spec]
            : [...existing.slice(0, idx), res.spec, ...existing.slice(idx + 1)];
        this.serviceSpecsUpdate.emit(this.serviceSpecs);
      }
    });
  }

  delete(index: number) {
    const serviceSpecs = [
      ...this.serviceSpecs.slice(0, index),
      ...this.serviceSpecs.slice(index + 1)
    ];
    this.serviceSpecsUpdate.emit(serviceSpecs);
  }

  onClose(employee: any) {
  }
}
